import React, {
  Suspense,
  useMemo,
  useRef,
  lazy,
  createContext,
  useContext,
} from 'react';

import { LTLoader } from '@lambdatestincprivate/lt-components';

import { Provider } from 'react-redux';

import createMyStore from '../../redux/store';
import { initializeEnv } from '../../utils/env';
import './style.css';

const AutomationLogsPage = lazy(() => import('./AutomationLogsPageWrapper'));

const ComponentPageWrapper = lazy(() => import('./ComponentPageWrapper'));

const ComponentPages = ['playwright-trace', 'report-view'];
export const AutomationContext = createContext(null);

export default function App(props) {
  const env = useMemo(() => props.env ?? {}, [props.env]);
  const envInitRef = useRef(false);

  // Initialize env synchronously on first render to avoid an extra blank frame
  if (!envInitRef.current) {
    initializeEnv(env);
    envInitRef.current = true;
  }

  // Create store with env object
  const store = useMemo(() => {
    return createMyStore(env);
  }, [env]);

  if (!store) {
    return null;
  }

  return (
    <Provider store={store}>
      <AutomationContext.Provider
        value={{
          backToJobDetail: props?.backToJobDetail,
          fromHyperExecute: props?.fromHyperExecute,
          env: env,
          fromKane: props?.fromKane,
          backToKane: props?.backToKane,
          fromOtherProduct: props?.fromOtherProduct,
          dockMode: props?.dockMode,
          orgPreferences: props?.orgPreferences,
          highlightedCommandRanges: props?.highlightedCommandRanges,
        }}
      >
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                minHeight: '300px',
              }}
            >
              <LTLoader
                heading="Loading Test"
                description="Please wait while we load your test details"
              />
            </div>
          }
        >
          {
            // if we have to use a single component out of TestPageWeb
            // Then we can use this component wrapper to wrap the component so that store and env registration from here only
            // We can call it like this example: <TestPageWeb pageType="playwright-trace" />
            //pageType can be used to directly import that particular component out of TestPageWeb
            ComponentPages.includes(props.pageType) ? (
              <ComponentPageWrapper {...props} />
            ) : (
              <AutomationLogsPage {...props} />
            )}
        </Suspense>
      </AutomationContext.Provider>
    </Provider>
  );
}

export function useAutomationContext() {
  return useContext(AutomationContext);
}
